import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyB72HnJF6ByBglY2b_-Tl8pO_iBvkzLy_c",
    authDomain: "adivercapitalapp.firebaseapp.com",
    projectId: "adivercapitalapp",
    storageBucket: "adivercapitalapp.appspot.com",
    messagingSenderId: "17357192251",
    appId: "1:17357192251:web:039c07095506402f80b01e",
    measurementId: "G-EPG663CMR6"
});
const db = firebaseApp.firestore();
const auth = firebaseApp.auth();

// Export the database for components to use.
export { db };
export {auth};